// NOTE: Login
export const LOGIN_GOOGLE = 'LOGIN_GOOGLE'
export const LOGIN_MICROSOFT = 'LOGIN_MICROSOFT'
export const SET_LOGIN_STATE = 'SET_LOGIN_STATE'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'

// NOTE: Logout
export const LOGOUT_GOOGLE = 'LOGOUT_GOOGLE'
export const LOGOUT_MICROSOFT = 'LOGOUT_MICROSOFT'

export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN'
export const SET_CUSTOMER_NAME = 'SET_CUSTOMER_NAME'
export const SET_CUSTOMER_SETTING = 'SET_CUSTOMER_SETTING'
export const SET_ROLE = 'SET_ROLE'
export const SET_IS_ABEJA_ADMIN = 'SET_IS_ABEJA_ADMIN'
export const SET_IS_NEW_USER = 'SET_IS_NEW_USER'
export const SET_LICENSE_LIST = 'SET_LICENSE_LIST'
export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER'
